import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/regionen/aschaffenburg")({
  head: () => {
    const h = pageHead("region:aschaffenburg", "de");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="aschaffenburg" locale="de" />,
});
